import { render, staticRenderFns } from "./sectionTexts.vue?vue&type=template&id=dbe02a90&scoped=true"
import script from "./sectionTexts.vue?vue&type=script&lang=js"
export * from "./sectionTexts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbe02a90",
  null
  
)

export default component.exports